import styles from './index.scss'
import { TabBar } from 'antd-mobile'
import DpBusinessPopup from '@/libs/components/DpBusinessComponents/DpBusinessPopup'
import ServicePhone, { autoPhoneAction } from '@/libs/components/ServicePhone'
import { useMemo, useState } from 'react'
import goTo from '@/libs/functions/goTo'
import { setLocale, getLocale } from 'umi'
import IconTitle from './iconTitle'
import CustomerService from './customerService'

const DEFAULT_ICON_URL = 'https://oss-images.dragonpass.com.cn/business-saas/platform/2023-03-14_110846/temp'
const ORDER_ICON_URL = 'https://oss-images.dragonpass.com.cn/business-saas/platform/2023-03-14_110836/temp'
const HOME_ICON_URL = 'https://oss-images.dragonpass.com.cn/business-saas/platform/2023-03-14_110841/temp'
const REFRESH_ICON_URL = 'https://oss-images.dragonpass.com.cn/business-saas/platform/2024-09-14_111635/refresh.png'

const MODULE_NAME_KEY: Record<string, string> = {
  order: '订单列表',
  customer: '联系客服',
  home: '返回首页',
  personalService: '专属客服',
  refresh: '刷新',
}

type PropsType = {
  btnStyle?: React.CSSProperties
  tipsStyle?: React.CSSProperties
  itemStyles?: React.CSSProperties
  customStyle?: React.CSSProperties
  type?: string
  onSubmit?: any
  h5Config?: any
  hiddenName?: boolean
  data?: {
    showTips?: boolean // 是否展示tips
    tips?: string // tips
    categoryType?: string // 类型，去订单详情直接筛选吧
  }
  h5Setting?: {
    showLocales?: boolean // 多语种

    servicePhoneName?: string // 客服电话title
    servicePhoneImg?: any[string] // 客服电话img
    showServicePhone?: boolean // 是否开启平台电话
    servicePhoneContent?: any[], // 平台电话

    showHomePage?: boolean // 是否开启home
    homePageName?: string // home名称
    homePagePath?: string // homeURl
    homePageUrl?: string // homeURl
    homePageImg?: any[string]

    showOrderEntry?: boolean // 是否开启订单
    orderEntryName?: string // 订单名称
    orderPageUrl?: string // 订单路径
    orderEntryImg?: any[string]
    
    refreshImg?: any[string] // 刷新图片
    showRefresh?: boolean

    personalServicePhoneName?: string // 专属电话title
    showPersonalServicePhone?: boolean // 专属客服
    personalServiceTels?: any[] // 专属客服
    personalServicePhoneImg?: any[string] // 专属电话
    
    customerServiceTemplate?: any // 客服模板[string]

  }
  onClickFun?: Function
  onRefresh?: Function
  trackerPermission?: string[]
  msgType?: string // msgTemplate、productSetting
}

// 语种信息
const SysLocales = (props: any) => {
  const [visible, updateVisible] = useState(false)
  return <>
    <IconTitle onClick={() => updateVisible(true)} hiddenName={props?.hiddenName} title={getLocale() === 'en' ? 'EN' : '中文'} src={props?.h5Setting?.servicePhoneImg?.[0] || DEFAULT_ICON_URL}  />
    <DpBusinessPopup
      visible={visible}
      onClose={() => {
        updateVisible(false)
      }}
      title={'切换语种'}
      bodyStyle={{ zIndex: 999999, ...props?.customStyle }}
      headerStyle={{ textAlign: 'center', borderWidth: 0, padding: '8px 20px' }}
      popupBodyStyles={{
        minHeight: 160,
        maxHeight: '80vh'
      }}
      containerStyles={{
        padding: '8px 20px'
      }}
    >
      <>
        <div className={styles['dp-business-toolbar-tels']} >
          {[{
            label: '中文',
            value: 'zh-CN'
          }, {
            label: 'EN',
            value: 'en'
          }]?.map?.((item, index: number) => <div onClick={() => setLocale(item?.value)} className={styles['dp-business-toolbar-tels-item']} key={index}>{item?.label}</div>)}
        </div>
      </>
    </DpBusinessPopup>
  </>
}


const DpBusinessToolbar = (props: PropsType) => {
  const { trackerPermission = [], msgType = 'productSetting' } = props
  const [servicePhonePopupVisible, setServicePhonePopupVisible] = useState(false)

  const onSendClickTracker = (key: string) => {
    if (trackerPermission?.includes(key)) {
      window?.dpTracker?.sendClk({
        eventData: {
          module_name: MODULE_NAME_KEY[key] || key,
        }
      })
    }
  }

  const handleClick = (key: string, url: string) => {
    props?.onClickFun?.(key) || goTo(url)
  }

  const tabs = useMemo(() => [
    {
      key: 'order',
      title: <IconTitle itemStyles={props?.itemStyles} hiddenName={props?.hiddenName} onClick={() => {
        onSendClickTracker('order')
        handleClick('order', props?.h5Setting?.orderPageUrl || `/order/orderRecord?categoryType=${props?.data?.categoryType || ''}`)
      }} title={props?.h5Setting?.orderEntryName || '订单'}  src={props?.h5Setting?.orderEntryImg?.[0] || ORDER_ICON_URL} />,
      hidden: !props?.h5Setting?.showOrderEntry,
    },
    {
      key: 'customer',
      title: <CustomerService
        {...props}
        title={props?.h5Setting?.servicePhoneName || '客服'}
        src={props?.h5Setting?.servicePhoneImg?.[0] || DEFAULT_ICON_URL} 
        onClick={() => {
          onSendClickTracker('customer')
          props?.onClickFun?.('customer')
        }}
        trackerPermission={trackerPermission}
      />,
      hidden: !props?.h5Setting?.showServicePhone || msgType === 'msgTemplate' || props?.h5Setting?.customerServiceTemplate?.entryPosition === 'float'
    },
    {
      key: 'customer-template',
      title: <IconTitle itemStyles={props?.itemStyles} hiddenName={props?.hiddenName} onClick={() => {
        onSendClickTracker('customer')
        autoPhoneAction(props?.h5Setting?.customerServiceTemplate || {}, () => {
          setServicePhonePopupVisible(true)
        })
      }} title={props?.h5Setting?.customerServiceTemplate?.entryDescription || '客服'} src={props?.h5Setting?.customerServiceTemplate?.iconSetting || DEFAULT_ICON_URL} />,
      hidden: !props?.h5Setting?.customerServiceTemplate?.customerInfoDTO || msgType === 'productSetting' || props?.h5Setting?.customerServiceTemplate?.entryPosition === 'float'
    },
    {
      key: 'home',
      title: <IconTitle itemStyles={props?.itemStyles} hiddenName={props?.hiddenName} onClick={() => {
        onSendClickTracker('home')
        handleClick('home', props?.h5Setting?.homePageUrl || props?.h5Setting?.homePagePath || '')
      }} title={props?.h5Setting?.homePageName || '首页'} src={props?.h5Setting?.homePageImg?.[0] || HOME_ICON_URL} />,
      hidden: !props?.h5Setting?.showHomePage
    },
    {
      key: 'locales',
      title: <SysLocales {...props} />,
      hidden: !props?.h5Setting?.showLocales
    },
    {
      key: 'refresh',
      title: <IconTitle itemStyles={props?.itemStyles} hiddenName={props?.hiddenName} onClick={() => {
        onSendClickTracker('refresh')
        props?.onRefresh?.()
      }} title={'刷新'} src={props?.h5Setting?.refreshImg?.[0] || REFRESH_ICON_URL} />,
      hidden: !props?.h5Setting?.showRefresh
    },
    {
      key: 'personalService',
      title: <CustomerService
        {...props}
        title={props?.h5Setting?.personalServicePhoneName || '专属客服'}
        onClick={() => {
          onSendClickTracker('personalService')
          props?.onClickFun?.('personalService')
        }}
        src={props?.h5Setting?.personalServicePhoneImg?.[0] || DEFAULT_ICON_URL} 
      />,
      hidden: !props?.h5Setting?.showPersonalServicePhone
    },
  ], [props, trackerPermission, msgType, servicePhonePopupVisible])

  return (
    <div className={styles[`dp-business-toolbar-${props?.type}`]} style={props?.customStyle}>
      <TabBar
        activeKey={'99999'}
        className={styles["dp-business-toolbar"]}
        style={props?.customStyle}
      >
        {tabs.map(item => !item?.hidden && <TabBar.Item key={item.key} title={item?.title} />)}
      </TabBar>
      { msgType === 'msgTemplate' && (
        <>
          {props?.h5Setting?.customerServiceTemplate?.entryPosition === 'float' && <ServicePhone.Bubble templateInfo={props?.h5Setting?.customerServiceTemplate} />}
          <ServicePhone.Popup
            title={props?.h5Setting?.customerServiceTemplate?.entryDescription}
            visible={servicePhonePopupVisible}
            phoneList={props?.h5Setting?.customerServiceTemplate?.customerInfoDTO?.servicePhoneContentObjs ?? []}
            onCancel={() => setServicePhonePopupVisible(false)}
          />
        </>
      )}
    </div>
  )
}

export default DpBusinessToolbar
